module.exports = __webpack_public_path__ + "img/Vertiefung.151a4121.svg";